{
    "Accessibility menu": "เมนูการช่วยการเข้าถึง",
    "Close": "ปิด",
    "Text and Reading": "ข้อความและการอ่าน",
    "Navigation and Interaction": "การนำทางและการโต้ตอบ",
    "Text Align": "การจัดแนวข้อความ",
    "Align Left": "จัดชิดซ้าย",
    "Align Center": "จัดกึ่งกลาง",
    "Align Right": "จัดชิดขวา",
    "Adjust Font Size": "ปรับขนาดตัวอักษร",
    "Highlight Title": "เน้นหัวเรื่อง",
    "Highlight Links": "เน้นลิงก์",
    "Readable Font": "แบบอักษรที่อ่านง่าย",
    "Color and Contrast": "สีและคอนทราสต์",
    "Dark Contrast": "ความเปรียบต่างเข้ม",
    "Light Contrast": "ความเปรียบต่างสว่าง",
    "High Contrast": "ความเปรียบต่างสูง",
    "High Saturation": "ความอิ่มตัวของสีสูง",
    "Low Saturation": "ความอิ่มตัวของสีต่ำ",
    "Monochrome": "โมโนโครม",
    "Tools": "เครื่องมือ",
    "Reading Guide": "แถบช่วยอ่าน",
    "Big Cursor": "เคอร์เซอร์ขนาดใหญ่",
    "Increase Font Size": "เพิ่มขนาดตัวอักษร",
    "Decrease Font Size": "ลดขนาดตัวอักษร",
    "Letter Spacing": "ระยะห่างระหว่างตัวอักษร",
    "Line Height": "ความสูงของบรรทัด",
    "Font Weight": "น้ำหนักตัวอักษร",
    "Dyslexia Font": "แบบอักษรสำหรับดิสเล็กเซีย",
    "Language": "ภาษา",
    "Accessibility widget": "เปิดเมนูการช่วยการเข้าถึง",
    "Accessibility Profiles": "โปรไฟล์การช่วยการเข้าถึง",
    "Cognitive Disability": "ความบกพร่องทางการรับรู้",
    "Seizure Safe": "ปลอดภัยสำหรับโรคลมชัก",
    "Accessibility statement": "คำแถลงการช่วยการเข้าถึง",
    "ADHD": "สมาธิสั้น",
    "Low Vision": "สายตาเลือนราง",
    "Pause Animations": "หยุดการเคลื่อนไหว",
    "Animation paused": "หยุดแอนิเมชันชั่วคราว",
    "Reset all settings": "รีเซ็ตการตั้งค่า",
    "Shortcut:": "ทางลัด:",
    "Epilepsy Safe Mode": "โหมดปลอดภัยสำหรับผู้เป็นลมชัก",
    "Mute sounds": "ปิดเสียง",
    "Page read": "อ่านออกเสียงหน้าเว็บ",
    "Page read controls": "ตัวควบคุมการอ่านออกเสียง",
    "Pause": "หยุดชั่วคราว",
    "Resume": "เล่นต่อ",
    "Stop": "หยุด",
    "Settings": "การตั้งค่า",
    "Speed": "ความเร็ว",
    "Voice": "เสียง",
    "Close accessibility menu": "ปิดเมนูการช่วยการเข้าถึง",
    "Back to accessibility menu": "กลับไปที่เมนูการช่วยการเข้าถึง",
    "Search languages": "ค้นหาภาษา",
    "Selected language": "ภาษาที่เลือก",
    "View accessibility statement (opens in new window)": "ดูคำชี้แจงการช่วยการเข้าถึง (เปิดในหน้าต่างใหม่)",
    "Visit CookieYes website (opens in new window)": "เยี่ยมชมเว็บไซต์ CookieYes (เปิดในหน้าต่างใหม่)",
    "Reset all accessibility settings to default": "รีเซ็ตการตั้งค่าการช่วยการเข้าถึงทั้งหมดเป็นค่าเริ่มต้น"
}
